import React from "react";
import { useNavigate } from "react-router-dom";

function HomeScreen() {
  const navigate = useNavigate();

  const handleButtonClick = (value) => {
    navigate("/data-management", { state: { value } });
  };

  return (
    <div className="flex flex-col p-5">
      <div className="grid grid-cols-2 gap-6 w-full">
        <button
          className="w-full p-6 text-xl font-semibold rounded-2xl shadow-md transition duration-200 bg-primary text-white hover:bg-secondary-light hover:text-white hover:scale-105 focus:text-white focus:font-semibold focus:shadow-lg"
          onClick={() => handleButtonClick("houseDesign")}
        >
          House Design
        </button>
        <button
          className="w-full p-6 text-xl font-semibold rounded-2xl shadow-md transition duration-200 bg-primary text-white hover:bg-secondary-light hover:text-white hover:scale-105 focus:text-white focus:font-semibold focus:shadow-lg"
          onClick={() => handleButtonClick("construction")}
        >
          Construction Calculators
        </button>
        <button
          className="w-full p-6 text-xl font-semibold rounded-2xl shadow-md transition duration-200 bg-primary text-white hover:bg-secondary-light hover:text-white hover:scale-105 focus:text-white focus:font-semibold focus:shadow-lg"
          onClick={() => handleButtonClick("shop")}
        >
          Shop
        </button>
        <button
          className="w-full p-6 text-xl font-semibold rounded-2xl shadow-md transition duration-200 bg-primary text-white hover:bg-secondary-light hover:text-white hover:scale-105 focus:text-white focus:font-semibold focus:shadow-lg"
          onClick={() => handleButtonClick("projects")}
        >
          Our Projects
        </button>
        {/* <button
          className="w-full p-6 text-xl font-semibold rounded-2xl shadow-md transition duration-200 bg-primary text-white hover:bg-secondary-light hover:text-white hover:scale-105 focus:text-white focus:font-semibold focus:shadow-lg"
          onClick={() => handleButtonClick("frontElevation")}
        >
          Front Elevation
        </button> */}
        <button
          className="w-full p-6 text-xl font-semibold rounded-2xl shadow-md transition duration-200 bg-primary text-white hover:bg-secondary-light hover:text-white hover:scale-105 focus:text-white focus:font-semibold focus:shadow-lg"
          onClick={() => handleButtonClick("blog")}
        >
          Blogs
        </button>
        <button
          className="w-full p-6 text-xl font-semibold rounded-2xl shadow-md transition duration-200 bg-primary text-white hover:bg-secondary-light hover:text-white hover:scale-105 focus:text-white focus:font-semibold focus:shadow-lg"
          onClick={() => handleButtonClick("interiorDesign")}
        >
          Interior Design
        </button>
      </div>
    </div>
  );
}

export default HomeScreen;